import type { Creature, CreatureDef } from '~/types/game'
import { makeId } from '~/utils/random'

/** A fresh level-1 creature from its definition. Lifted out of useRun in
 * v7.04 so the encounter (the First Dispatch's mid-node arrival) can mint
 * one without importing the run composable back into itself. */
export function makeCreature(def: CreatureDef): Creature {
  return {
    id: makeId(def.id),
    defId: def.id,
    name: def.name,
    level: 1,
    xp: 0,
    stats: { ...def.stats },
    speed: def.speed,
    // 🌟 Rares carry innate ⚔️ Fight (v1.01).
    fight: def.fight ?? 0,
    injured: false,
    available: true,
    pendingStatPoints: 0,
    assignedMissionId: null,
    surgePrimed: false,
    surgeCooldown: 0,
  }
}
